// extracted by css-extract-rspack-plugin
export default {"ansiLogs":"gMuNa"};